import { useState } from 'react'
import { GlassmorphicCard } from '@/components/ui/glassmorphic-card'
import { MessageSquare, Search } from 'lucide-react'

const mockConversations = [
    { id: 'conv1', mentorName: 'Dr. Sarah Patel', studentName: 'Arun K', lastMessage: 'Need help with Thermodynamics', time: '2m ago', unread: 2 },
    { id: 'conv2', mentorName: 'Dr. Rajesh Kumar', studentName: 'Priya S', lastMessage: 'Thank you for the notes', time: '1h ago', unread: 0 },
]

export function AdminChatsView() {
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const [search, setSearch] = useState('')

    const selected = mockConversations.find(c => c.id === selectedId)

    return (
        <div className="flex h-[calc(100dvh-180px)] lg:h-[calc(100vh-140px)] gap-4 pb-24 lg:pb-0 overflow-hidden">
            <div className={`w-full md:w-80 flex flex-col gap-4 ${selectedId ? 'hidden md:flex' : 'flex'}`}>
                <GlassmorphicCard className="flex-1 flex flex-col overflow-hidden">
                    <div className="p-4 border-b border-slate-100 dark:border-slate-800">
                        <h2 className="font-bold text-theme-primary mb-4">All Chats (View)</h2>
                        <div className="relative">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-theme-secondary" />
                            <input
                                type="text"
                                placeholder="Search mentor or student..."
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                className="w-full pl-9 pr-4 py-2 rounded-lg bg-slate-50 dark:bg-slate-800/50 border-none text-sm focus:ring-2 focus:ring-primary-blue outline-none text-theme-primary"
                            />
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto">
                        {mockConversations.map(c => (
                            <button
                                key={c.id}
                                onClick={() => setSelectedId(c.id)}
                                className={`w-full p-4 flex flex-col gap-1 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors border-b border-slate-50 dark:border-slate-800 text-left ${selectedId === c.id ? 'bg-blue-50 dark:bg-blue-900/20' : ''}`}
                            >
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold text-theme-primary">{c.mentorName} ↔ {c.studentName}</span>
                                    {c.unread > 0 && <span className="w-5 h-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center">{c.unread}</span>}
                                </div>
                                <p className="text-sm text-theme-secondary truncate">{c.lastMessage}</p>
                                <p className="text-xs text-theme-muted">{c.time}</p>
                            </button>
                        ))}
                    </div>
                </GlassmorphicCard>
            </div>

            <GlassmorphicCard className={`flex-1 flex flex-col overflow-hidden ${selectedId ? 'flex' : 'hidden md:flex'}`}>
                {selected ? (
                    <>
                        <div className="p-4 border-b border-slate-100 dark:border-slate-800">
                            <h3 className="font-bold text-theme-primary">{selected.mentorName} ↔ {selected.studentName}</h3>
                            <p className="text-sm text-theme-secondary">Admin view-only. Mentors and students chat in their portals.</p>
                        </div>
                        <div className="flex-1 overflow-y-auto p-4 space-y-3">
                            <div className="flex justify-start">
                                <div className="max-w-[80%] rounded-2xl rounded-bl-none bg-slate-100 dark:bg-slate-800 px-4 py-2">
                                    <p className="text-sm text-theme-primary">Hi, I need help with Thermodynamics.</p>
                                    <p className="text-xs text-theme-muted mt-1">10:30 AM</p>
                                </div>
                            </div>
                            <div className="flex justify-end">
                                <div className="max-w-[80%] rounded-2xl rounded-br-none bg-primary-blue text-white px-4 py-2">
                                    <p className="text-sm">Sure, which topic?</p>
                                    <p className="text-xs opacity-80 mt-1">10:32 AM</p>
                                </div>
                            </div>
                        </div>
                        <div className="p-4 border-t border-slate-100 dark:border-slate-800">
                            <p className="text-xs text-theme-muted">Admin can view conversations for support. Reply from Mentor/Student portal.</p>
                        </div>
                    </>
                ) : (
                    <div className="flex-1 flex items-center justify-center text-theme-secondary">
                        <div className="text-center">
                            <MessageSquare className="h-12 w-12 mx-auto mb-2 opacity-50" />
                            <p>Select a conversation to view</p>
                        </div>
                    </div>
                )}
            </GlassmorphicCard>
        </div>
    )
}
